import { jvBanks } from "./jvBanks";

export const formFieldsBank = [
    {
        label: <div className="mb-2">Παρακαλώ επιλέξτε το Πιστωτικό Ίδρυμα που επιθυμείτε για τον τραπεζικό δανεισμό σας: <span className="color-red"> *</span></div>, 
        type: 'select',
        name: 'bnkBank',
        id: 'bnkBank',
        placeholder: 'Επιλέξτε Πιστωτικό Ίδρυμα',
        span: 24,
        // asterisk:true,
        className: 'like-text',
        size: 'medium',
        options: jvBanks,
        rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      },
]